export default __webpack_public_path__ + "static/media/academic-support.2279d4c2.jpg";